angular.module('ikeweb.layout').controller('PageHeaderController', ['$scope', '$rootScope', 'loginService', '$location', 'billingService',
    function($scope, $rootScope, $loginService, $location, billingService) {

        var pathsWithoutHeader = [
            '/login',
            '/signup',
            '/forgotPassword',
            '/choose_password',
            '/invalid_link',
            '/password_reset_success',
            '/error/.*'
        ];

        var isPro = false;

        function pathRequiresHeader(path) {
            return !pathsWithoutHeader.reduce(function(result, pathWithoutHeader) {
                return result || new RegExp(pathWithoutHeader).test(path);
            }, false);
        }

        $scope.showHeader = function() {
            return pathRequiresHeader($location.path());
        };

        function update() {
            var user = $loginService.getLoggedInUser();
            if (user) {
                $scope.username = user.getUsername();
                $scope.showNav = true;
                billingService.isOnPremium().then(function(isPremium) {
                    isPro = isPremium;
                });
            } else {
                $scope.showNav = false;
            }

            $scope.location = $location.path();
        };

        $scope.isPro = function() {
            return isPro;
        };

        $scope.isMeasurementLocation = function() {
            return $location.path().indexOf('gallery') > -1;
        };

        $scope.getPathHeaderClass = function() {
            var location = $location.path();
            return 'HeaderNav-route-' + location.replace(/^\/([^\/]*).*$/, '$1');
        };

        $scope.logout = function() {
            $loginService.logout();
        };

        $rootScope.$on('$locationChangeSuccess', update);
        update();
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/header/header-nav.controller.js
// module id = 462
// module chunks = 0